module.exports = __webpack_public_path__ + "static/img/trend-4.a23363e4.png";